import { useQuery } from "@tanstack/react-query";
import { UseFormReturn, useWatch } from "react-hook-form";

import { loadProducts } from "../core/product.core";
import { ProductListFilter, ProductStatus, ProductType, SortAsec, SortKey } from "../types/product";

export default function useProductQuery(methods: UseFormReturn<ProductListFilter, any>) {
  const [
    pageSize,
    search,
    categoryIds,
    brandIds,
    priceMin,
    priceMax,
    isPromotionProduct,
    rewardPayoutMin,
    rewardPayoutMax,
    statuses,
    page,
    sort,
    sortAsec,
    tagId,
    withInventories,
    attributesIds,
    productTypes
  ] = useWatch({
    name: [
      "pageSize",
      "search",
      "categoryIds",
      "brandIds",
      "priceMin",
      "priceMax",
      "isPromotionProduct",
      "rewardPayoutMin",
      "rewardPayoutMax",
      "statuses",
      "page",
      "sort",
      "sortAsec",
      "tagId",
      "withInventories",
      "attributesIds",
      "productTypes"
    ],
    control: methods.control,
  });

  return useQuery({
    queryKey: [
      "products",
      page,
      pageSize,
      search,
      categoryIds,
      brandIds,
      priceMin,
      priceMax,
      isPromotionProduct,
      rewardPayoutMin,
      rewardPayoutMax,
      statuses,
      sort,
      sortAsec,
      tagId,
      withInventories,
      attributesIds,
      productTypes
    ],
    queryFn: (context) =>
      loadProducts({
        paging: {
          page: context.queryKey[1] as number,
          size: context.queryKey[2] as number,
        },
        search: context.queryKey[3] as string,
        categoryIds: context.queryKey[4] as string[],
        brandIds: context.queryKey[5] as string[],
        priceMin: context.queryKey[6] as number,
        priceMax: context.queryKey[7] as number,
        isPromotionProduct: context.queryKey[8] as boolean,
        rewardPayoutMin: context.queryKey[9] as number,
        rewardPayoutMax: context.queryKey[10] as number,
        statuses: context.queryKey[11] as ProductStatus[],
        sort: context.queryKey[12] as SortKey,
        sortAsec: context.queryKey[13] as SortAsec,
        tagId: context.queryKey[14] as string,
        withInventories: (context.queryKey?.[15] as boolean) ?? true,
        attributesIds: context.queryKey[16] as string[],
        productTypes: context.queryKey[17] as ProductType[]
      }),
  });
}
